import { useQuery } from '@tanstack/react-query';
import { getOutputDeliverableMetrics } from '@/services/composer-dashboard/get-output-deliverable-metrics';
import { OutputDeliverableMetricsResponse } from '@/types/composer-dashboard';
import { useOrgStore } from '@/stores/org-store';

export const useGetOutputDeliverableMetrics = (labelIds?: string[]) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<OutputDeliverableMetricsResponse, Error>({
    queryKey: ['composer-output-deliverable-metrics', orgId, labelIds ?? []],
    queryFn: () => getOutputDeliverableMetrics(orgId!, labelIds),
    enabled: !!orgId,
    retry: 1,
    staleTime: 60000,
  });
};
